/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RecurringPlan
 */
export interface RecurringPlan {
    /**
     *
     * @type {number}
     * @memberof RecurringPlan
     */
    id: number;
    /**
     *
     * @type {string}
     * @memberof RecurringPlan
     */
    name: string;
    /**
     *
     * @type {number}
     * @memberof RecurringPlan
     */
    numberOfMonths: number;
}

/**
 * Check if a given object implements the RecurringPlan interface.
 */
export function instanceOfRecurringPlan(value: object): value is RecurringPlan {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function RecurringPlanFromJSON(json: any): RecurringPlan {
    return RecurringPlanFromJSONTyped(json, false);
}

export function RecurringPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecurringPlan {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'name': json['name'],
        'numberOfMonths': json['number_of_months'],
    };
}

export function RecurringPlanToJSON(json: any): RecurringPlan {
    return RecurringPlanToJSONTyped(json, false);
}

export function RecurringPlanToJSONTyped(value?: RecurringPlan | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'id': value['id'],
        'name': value['name'],
        'number_of_months': value['numberOfMonths'],
    };
}
